import {Link} from 'react-router'
import styles from './NavNotLoggedIn.css'
const BACKEND_HOST = process.env.BACKEND_HOST
const BACKEND_PORT = process.env.BACKEND_PORT

class NavNotLoggedIn extends React.Component {
  render () {
    const signInStyle = this.props.location.pathname === '/login' ? { color: 'white' } : {}
    const SUPPORT_PAGE = `${BACKEND_HOST}:${BACKEND_PORT}/support`
    return (
      <div className={`navbar-collapse collapse header-login ${styles.wrapper}`} id='NavNotLoggedIn'>
        <ul className={`nav navbar-nav mk-navbar-nav navbar-right text-center ${styles['list-menu']}`}>
          <li><a href={SUPPORT_PAGE} data-toggle='collapse' data-target='.navbar-collapse.in'>help</a></li>
          <li><Link to='/login' data-toggle='collapse' data-target='.navbar-collapse.in' style={signInStyle}>Sign In</Link></li>
        </ul>
      </div>
    )
  }
}

export default NavNotLoggedIn



// WEBPACK FOOTER //
// ./app/components/Nav/NavNotLoggedIn/NavNotLoggedIn.js